import React from 'react';
import '../styling/AboutPage.css';

function AboutPage() {
  return (
    <section className="about-section">
      <div className="about-content container">
        <div className="row">
          <div className="col-12 col-lg-6 about-text order-2 order-lg-2">
            <p>
              At Kyro Studios, creativity meets technology to shape the future of interactive entertainment. With a passion for innovative design and compelling storytelling, we're committed to crafting immersive games that push the boundaries of what's possible.
            </p>
            <p>
              Embracing emerging technologies and forward-thinking concepts, each project is a journey into new realms of gameplay and narrative. Join us in exploring a future where digital worlds come alive with unforgettable experiences.
            </p>
          </div>
          <div className="col-lg-5 about-title order-lg-2 d-none d-lg-block">
            <p>WHO</p>
            <p>WE</p>
            <p>ARE</p>
          </div>
          <div className="col-12 about-title-mobile order-1 d-lg-none">
            <p className='title-mobile'>WHO WE ARE</p>
          </div>
        </div>
       
      </div>
    </section>
  );
}

export default AboutPage;
